import type { FC } from 'react';
import type { LineProps } from './index';

export const BallLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height="8" viewBox="0 0 90 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4H88" stroke={color} strokeWidth={height} />
            <circle cx="2" cy="4" r="2" fill={color} />
            <circle cx="14" cy="4" r="2" fill={color} />
            <circle cx="26" cy="4" r="2" fill={color} />
            <circle cx="38" cy="4" r="2" fill={color} />
            <circle cx="50" cy="4" r="2" fill={color} />
            <circle cx="62" cy="4" r="2" fill={color} />
            <circle cx="74" cy="4" r="2" fill={color} />
            <circle cx="86" cy="4" r="2" fill={color} />
        </svg>
    );
};
